// The Quick-start guide for the person's role (each screen's "?" opens the matching User Manual page: shared/helpcentre.ts).
import { state } from "./state.js";

export type GuideRole = "admin" | "merchandiser" | "qc" | "inspector" | "viewer" | "supplier" | "agent" | "sales" | "salesmanager";
export const guideRoleFor = (): GuideRole => {
  const r = state.session.actor?.role;
  // Falcon CRM only: the Sales guide for their CRM role.
  const m = state.session.membership;
  if (m && m.crmAccess && !m.plmAccess && !state.session.actor?.supportAccess) return m.crmRole === "manager" || r === "Admin" ? "salesmanager" : "sales";
  return r === "Admin" ? "admin" : r === "Merchandiser" ? "merchandiser" : r === "QC inspector" ? "inspector" : r === "Supplier" ? "supplier" : r === "Agent" ? "agent" : "viewer";
};

